<!--
 * @Description: 
 * @Author: 山淑兰
 * @Date: 2019-09-06 15:12:11
 * @LastEditTime: 2020-05-13 17:22:59
 * @LastEditors: 山淑兰
 -->
<template>
    <div class="my">
        <main>
            <div class="newmeeting-title">
              我的参会记录
            </div>
            <div v-for="(item,index) in goodsListA"  :key='index'>
                <div class="newmeetinglist">
                    <div class="newmeetingline"></div>
                    <div class="newmeeting-flex">
                      <div class="newmeeting-date">
                          <div class="year">{{item.year}}</div>
                          <div class="month">{{item.month}}</div>
                      </div>
                      <div class="datemeetingcon">
                          <div class="datemeeting" v-for="(listitem,i) in item.list"  :key='i'>
                              <div class="newmeeting-img">
                                  <img :src="listitem.MeetingBannerImg?listitem.MeetingBannerImg:'../../assets/activity.jpg'">
                              </div>
                              <div class="newmeeting-name">{{listitem.MeetingName}}</div>
                              <div class="newmeeting-time">
                                  <img src="../../assets/time.png">
                                  {{listitem.MeetingTimer?listitem.MeetingTimer:''}}
                              </div>
                              <div class="newmeeting-add">
                                  <img src="../../assets/address.png">
                                  {{listitem.MeetingAddress?listitem.MeetingAddress:''}}
                              </div>
                              <div class="newmeeting-btn" @click="detail($event,listitem.MeetingLink)">
                                进入官网
                              </div>
                          </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="nodata" v-if="nodataShow">
              暂无数据
            </div>
        </main>
    </div>
</template>
<script>
import Cookies from 'js-cookie'
import { Dialog } from 'vant'
import Back from './components/backBtn.vue'
export default {
    name: 'joinMeeting',
    data() {
        return {
          clickId: -1,
          goodsList: [],
          goodsListA: [],
          hiddenName: true,
          pageNum: 1,
          nodataShow: false
        }
    },
    created() {
        this.meetingInfo()
    },
    methods: {
        async meetingInfo() {
          let that= this
            try {
                const res = await this.$http.joinMeeting();
                console.error(res);
                let goodsListNew = res.MeetingList
                if ( goodsListNew.length > 0 ) {
                    var oldDataRule = []
                    goodsListNew.forEach(el => {
                        var oldObj = {
                            date: el.MeetingStartTimer.substr(0, 7),
                            year: el.MeetingStartTimer.substr(0, 4),
                            month: el.MeetingStartTimer.substr(5, 2),
                            list: []
                        }
                        oldObj.list.push(el)
                        oldDataRule.push(oldObj)
                    })
                    var newData = []
                    var newObj = {}
                    oldDataRule.forEach((el, i) => {
                        if (!newObj[el.date]) {
                            newData.push(el);
                            newObj[el.date] = true;
                        } else {
                            newData.forEach(el => {
                                if (el.date === oldDataRule[i].date) {
                                    el.list = el.list.concat(oldDataRule[i].list);
                                    // el.list = [...el.list, ...oldDataRule[i].list]; // es6语法
                                }
                            })
                        }
                    })
                    that.goodsListA = newData
                    console.log(that.goodsListA)
                }else{
                  that.nodataShow = true
                }
            } catch (error) {
                console.error(error);
            }
        },
        detail(e,link){
          if (link == null && link == '') {
            this.$notify({
              message: '暂时没有详情!',
              type: 'danger',
            })
          }else{
            window.location.href = link
          }
        },
    }

};
</script>
<style lang="scss">
.my {
    padding-bottom: 85px;

    .newmeeting-title{
      font-size: 30px;
      color: #1e293b;
      padding: 20px;
      border-bottom: 1px solid #e2e8f0;
      background: #fff;
      margin-bottom: 20px;
      text-align: center;
    }
    .newmeetinglist {
        position: relative;
        display: flex;
        padding: 0 20px;
    }

    .newmeetingline {
        position: absolute;
        top: 30px;
        bottom: 0;
        left: 108px;
        width: 3px;
        height: 100%;
        background: #3b82f6;
    }

    .newmeeting-flex{
      width: 100%;
      display: flex;
    }

    .newmeeting-date {
        position: relative;
        width: 60px;
        text-align: center;
        padding-right: 30px;
        margin-right: 30px;
        
    }

    .month {
        font-size: 38px;
        font-weight: bold;
        color: #1e293b;
    }

    .year {
        color: #64748b;
        font-size: 26px;
    }

    .newmeeting-date:after {
        position: absolute;
        right: -15px;
        top: 30px;
        z-index: 100;
        display: block;
        content: '';
        width: 24px;
        height: 24px;
        background: #fff;
        border: 3px solid #3b82f6;
        border-radius: 50%;
    }

    .datemeetingcon {
        flex: 1;
    }

    .datemeeting {
        position:relative;
        width: 100%;
        padding: 15px 0;
        margin-bottom: 10px;
        border-bottom: 1px solid #e2e8f0;
    }

    .newmeeting-img {
        width: 100%;
    }

    .newmeeting-img img {
        display: block;
        width: 100%;
    }

    .newmeeting-name {
        color: #1e293b;
        font-size: 26px;
        margin-top: 10px;
    }


    .newmeeting-time,
    .newmeeting-add {
        color: #64748b;
        font-size: 24px;
        margin-top: 8px;
        padding-right: 160px;
    }

    .newmeeting-time img,
    .newmeeting-add img {
        width: 26px;
        height: 26px;
        vertical-align: -4px;
    }

    .newmeeting-btn{
      position: absolute;
      right: 0;
      bottom: 20px;
      width: 140px;
      height: 50px;
      background: #3b82f6;
      text-align: center;
      line-height: 50px;
      color: #fff;
      font-size: 28px;
    }
}
</style>